import { useState, useRef, useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Outlet } from "react-router-dom";
import { Text } from "../UI";
import theme from "../UI/theme";
import SearchImg from "../asserts/img/search_white.svg";
import CloseImg from "../asserts/img/close_white.svg";
import ListImg from "../asserts/img/list_white.svg";
import ListUnSelectedImg from "../asserts/img/list_uneleced.svg";
import CalenderUnSelectedImg from "../asserts/img/calender_unselected.svg";
import CalenderImg from "../asserts/img/calender_white.svg";
import DrawerImg from "../asserts/img/drawer_white.svg";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import MobileDateRange from "../components/MobileDateRange";
import DateFilter from "../components/DateFilter";
import { publish } from "../utils/events";
import ecxel from "../asserts/img/ecxel.png";

const StyledInput = styled.input(() => ({
  fontSize: 18,
  backgroundColor: theme.color.blue,
  color: theme.color.white,
  border: "none",
  "::placeholder": {
    color: theme.color.white,
  },
  lineHeight: 1,
}));

const MobileHeader = ({
  title,
  handleDateChange,
  handleSearchChange,
  handleEcxelClick,
  date,
  setDate,
  setCalencderView,
  calencderView,
  children,
}) => {
  const [isSearch, setIsSearch] = useState(false);
  const [isDate, setIsDate] = useState(false);
  const { t } = useTranslation("common");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isSearch) {
      inputRef.current?.focus();
    }
  }, [isSearch]);

  const handleMobileDateChange = (value) => {
    handleDateChange(value);
    setIsDate(false);
  };

  const showDrawer = () => {
    publish("showDrawer");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100vw",
          backgroundColor: theme.color.blue,
          padding: 10,
          gap: 24,
          paddingInline: 10,
          alignItems: "center",
        }}
      >
        {isSearch ? (
          <>
            <img
              src={SearchImg}
              alt="search"
              style={{ width: 20, height: 20 }}
            />
            <StyledInput
              ref={inputRef}
              placeholder={t("search")}
              onChange={handleSearchChange}
            />
            <img
              src={CloseImg}
              alt="close"
              style={{ width: 20, height: 20, marginInlineStart: "auto" }}
              onClick={(e) => {
                setIsSearch(false);
                handleSearchChange(e);
              }}
            />
          </>
        ) : (
          <>
            <img
              src={DrawerImg}
              alt="Drawer"
              style={{ width: 20, height: 20 }}
              onClick={showDrawer}
            />
            <Text.H1 style={{ fontSize: 20 }} color={theme.color.white}>
              {title}
            </Text.H1>
            <div
              style={{
                marginInlineStart: "auto",
                display: "flex",
                flexDirection: "row",
                gap: 24,
                paddingInlineEnd: 10,
              }}
            >
              {!!handleDateChange && (
                <img
                  src={CalenderImg}
                  alt="calender"
                  style={{ width: 20, height: 20 }}
                  onClick={() => {
                    setIsSearch(false);
                    setIsDate(true);
                  }}
                />
              )}
              {!!handleSearchChange && (
                <img
                  src={SearchImg}
                  alt="search"
                  style={{ width: 20, height: 20 }}
                  onClick={() => {
                    setIsSearch(true);
                    setIsDate(false);
                  }}
                />
              )}
              {!!setCalencderView && (
                <>
                  <img
                    src={!!calencderView ? ListUnSelectedImg : ListImg}
                    alt="listView"
                    style={{ width: 20, height: 20 }}
                    onClick={() => {
                      setCalencderView(false);
                    }}
                  />
                  <img
                    src={!!calencderView ? CalenderImg : CalenderUnSelectedImg}
                    alt="calenderView"
                    style={{ width: 20, height: 20 }}
                    onClick={() => {
                      setCalencderView(true);
                    }}
                  />
                </>
              )}
              {!!handleEcxelClick && (
                <>
                  <img
                    src={ecxel}
                    alt="ecxel"
                    style={{
                      width: 25,
                      height: 25,
                      alignSelf: "center",
                    }}
                    onClick={handleEcxelClick}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
      {!!isDate ? (
        <>
          <MobileDateRange
            setIsDate={setIsDate}
            handleDateChange={handleMobileDateChange}
          />
        </>
      ) : (
        <>
          <DateFilter date={date} setDate={setDate} />
          {children}
          <Outlet />
        </>
      )}
    </div>
  );
};

export default inject()(observer(MobileHeader));
